import styled from 'styled-components';

export const SeverityColor = styled.div`
    border-radius: 4px;
    width: 8px;
    height: 8px;
`;

export const ObserverName = styled.p`
    font-size: 16px;
    font-weight: 700;
`;

export const ObserverCreationDate = styled.span`
    font-size: 10px;
    font-weight: 500;
    opacity: 0.7
`;